import { coerceBooleanProperty } from "@angular/cdk/coercion";
import { Directive, ElementRef, Input, OnChanges, SimpleChange } from "@angular/core";
import { PlatformService } from "@obg/ngx.global";

@Directive({
	selector: "[obgScrollIntoView]",
})
export class ScrollIntoViewDirective implements OnChanges {
	@Input("obgScrollIntoView") scrollIntoView: boolean | undefined;

	constructor(
		private elementRef: ElementRef,
		private platformService: PlatformService
	) {}

	ngOnChanges(changes: { scrollIntoView?: SimpleChange }) {
		if (
			this.platformService.isServer ||
			!changes.scrollIntoView ||
			!coerceBooleanProperty(changes.scrollIntoView.currentValue)
		) {
			return;
		}

		const nativeElement = this.elementRef.nativeElement;
		const parentElement = nativeElement.parentElement;

		if (!parentElement) {
			return;
		}

		const productSelectorMaxWidth = 347;

		const isCenteringPossible =
			nativeElement.offsetWidth + nativeElement.offsetLeft === parentElement.scrollWidth ||
			parentElement.scrollWidth < productSelectorMaxWidth;

		if (parentElement && parentElement.scrollLeft < parentElement.clientWidth) {
			nativeElement.scrollIntoView({ block: "end", inline: isCenteringPossible ? "nearest" : "center" });
		}
	}
}
